<template>
    <b-modal id="show-modal" centered hide-footer no-close-on-backdrop size="md">
        <div class="row" v-if="facility_booking.id">
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.amount') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatAmount(facility_booking.charge.amount) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.name') }}</label>
                    <div class="col-7 col-form-label">
                        {{ facility_booking.parsed.full_name }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.checkin_date') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatDate(facility_booking.checkin_date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.checkout_date') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatDate(facility_booking.checkout_date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.reservation') }}</label>
                    <div class="col-7 col-form-label">
                        {{ facility_booking.pms_reservation_no }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.booking') }}</label>
                    <div class="col-7 col-form-label">
                        {{ $t(`booking_statuses.${facility_booking.booking_status.code}`) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.payment_authorized') }}</label>
                    <div class="col-7 col-form-label">
                        {{ formatDateTime(facility_booking.payment_metadata.date) }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.payment_captured') }}</label>
                    <div class="col-7 col-form-label">

                        {{
                            facility_booking.charge.captured ? formatDateTime(facility_booking.captured_date) : "--"
                        }}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.type') }}</label>
                    <div class="col-7 col-form-label text-capitalize">
                        {{ facility_booking.charge.payment_method_details.card.brand }} {{
                            facility_booking.charge.payment_method_details.card.funding}} {{
                            facility_booking.charge.payment_method_details.type}}
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class=" row">
                    <label class="col-5 col-form-label">
                        {{ $t('account-page-visitor-payments.number') }}</label>
                    <div class="col-7 col-form-label text-capitalize">
                        {{ facility_booking.charge.payment_intent }}
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <b-button class="mt-4" pill size="md" variant="primary" @click="$bvModal.hide('show-modal')">
                {{ $t("account-page-visitor-payments.back") }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import moment from "moment-timezone";
import formatters from '@/mixins/formatters.js';

export default {
    name: "StripeShow",
    data() {
        return {
            facility_booking: {

                charge: {
                    payment_method_details: {
                        card: {}
                    }
                }
            }
        }
    },
    methods: {

        async view(payment_id, facility_id) {
            let data = await this.$lionheart.get('facility-booking/list/payments/' + payment_id, { params: { facility_id: facility_id, timezone: moment.tz.guess() } }).then((success) => success.data.data);
            this.$data.facility_booking = data

            this.$bvModal.show('show-modal')
        }
    },
    mixins: [formatters],
}
</script>
